
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ children }) {
  const isVerified = localStorage.getItem('isVerified') === 'true';
  return isVerified ? children : <Navigate to="/otp-verification" replace />;
}

